import { contact } from '../../data/siteContent';

function ContactSection() {
  return (
    <section className="block contact-section" id="contact">
      <div className="wrap center">
        <span className="eyebrow">CONTACT</span>
        <h2 className="h2">지금, 편하게 연락 주세요</h2>
        <p className="sub">어떤 채널이든 좋아요. 작은 궁금증 하나도 괜찮습니다.<br />아래 <b>전화 · 카톡 · 인스타</b> 버튼으로 바로 연락 주세요.</p>
        <div className="contact-grid">
          <a className="contact-card call" href={`tel:${contact.phone}`}>
            <span className="contact-icon" aria-hidden="true">☎</span><h3>전화 상담</h3><p>{contact.phoneLabel}</p><span className="contact-go">전화 걸기</span>
          </a>
          <a className="contact-card kakao" href={contact.kakao} target="_blank" rel="noreferrer">
            <span className="contact-icon" aria-hidden="true">💬</span><h3>카카오톡</h3><p>1:1 오픈채팅 상담</p><span className="contact-go">카톡 상담하기</span>
          </a>
          <a className="contact-card instagram" href={contact.instagram} target="_blank" rel="noreferrer">
            <span className="contact-icon" aria-hidden="true">◎</span><h3>인스타그램</h3><p>@merim_insurance</p><span className="contact-go">DM 보내기</span>
          </a>
        </div>
        <div className="hours"><span>상담 가능 시간 · 평일 09:00–20:00</span><span>주말·공휴일 예약 상담</span><span>빠른 답변은 카카오톡</span></div>
      </div>
    </section>
  );
}

export default ContactSection;
